export const en = {
    cancel: 'Cancel',
    save: 'Save all formats',
    sidebarTitle: 'Sizes',
    subtitle: 'Now you can select the center of the image manually for each format.',
    title: 'Image positioning'
};
